import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireVideo } from "/Users/yvonne/Repositories/2. H1/Shopify-reisartikelen/theme/assets/video.js";
var videoExports = requireVideo();
export { videoExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(videoExports);